var map = {
	"./BaseBtn.vue": "2bcd",
	"./BtnBurger.vue": "c315",
	"./IconBag.vue": "71567",
	"./IconCard.vue": "32d4",
	"./IconFacebook.vue": "ed40",
	"./IconInstagram.vue": "b0419",
	"./IconKids.vue": "15cc",
	"./IconPhone.vue": "5de2",
	"./IconVeggie.vue": "ab9b",
	"./IconWheelchair.vue": "e84c",
	"./IconWifi.vue": "5d5c",
	"./IconZoom.vue": "f6ad",
	"./LogoSmall.vue": "395b",
	"./ScrollDownArrow.vue": "e871"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d340";